import { createSelector } from 'reselect';
import getFilteredCartErrors from './get-filtered-cart-errors';

const getLatestCartError = createSelector(getFilteredCartErrors, errors => errors[0]);

export default getLatestCartError;
